 // Whole Component Tejashwini
import React from "react";
import Layout from "./layout";
import { Button, Box,Typography  } from "@mui/material";
import { useNavigate } from 'react-router-dom';// Page linking using this 

const InventoryDashboard = () => {
    const navigate = useNavigate();// Page linking using this 
    return (
        <>
         
            <Layout /> 
           
             {/* <Typography className="title"
            //  variant="h4" sx={{ color: '#0A64A2', fontWeight: 'bold', fontFamily: 'sans-serif', textAlign: 'center', marginTop: '4em' }}
             >
               
            </Typography> */}
            <h1 className="title"> ERP Management</h1>
            <Box
            
                sx={{display: 'flex',justifyContent: 'center',alignItems: 'center',height: '70vh', gap: '9em', }}
            >       
           
                <Button onClick={() => {navigate('/erp-md') }} // Page linking using this 
                    variant="contained" 
                    sx={{ backgroundColor: '#0A64A2', color: '#fff', marginRight: '2em',marginBottom: '10em',borderRadius:'0.4em' ,padding: '41px 28px',fontSize: '14px',fontWeight: 'bold',fontFamily: ' sans-serif',
                    }}
                >
                    Inventory Management
                </Button>
                <Button  onClick={() => {navigate('/erp-store') }} // Page linking using this 
                    variant="contained" 
                    sx={{backgroundColor: '#0A64A2',color: '#fff', borderRadius:'0.4em' ,padding: '40px 40px',fontSize: '14px',marginBottom: '10em',fontWeight: 'bold',fontFamily: ' sans-serif',
                    }}
                >
                    Store Management
                </Button>
            </Box>
        </>
    );
}

export default InventoryDashboard;


 //Layout is JHS Dashboard
